export default{
    sendForm($v, cb) {
        let loop = () => {
            if (!$v.$invalid) {
                return cb(true);
            }
            if ($v.$invalid && $v.$pending) {
                return setTimeout(() => {
                    loop();
                }, 100);
            }
            return cb(false);
        };
        loop();
    }
}





// WEBPACK FOOTER //
// ./src/public_app/api/helpers.js